(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["edp-help"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('ic-edp-details-dialog');
    if (!dialog) return;
    const closeButton = dialog.querySelector('.ic-edp-close');

    const openDialog = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!dialog.open) dialog.showModal();
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    const enhanceEdp = () => {
      document.querySelectorAll('.bq-service-lines .service-label').forEach((label) => {
        if (label.dataset.icEdpHelp === 'true' || !label.textContent.includes('Equipment Damage Protection')) return;
        label.dataset.icEdpHelp = 'true';

        const wrap = document.createElement('span');
        wrap.className = 'ic-edp-help-wrap';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ic-edp-help-link';
        button.textContent = dialog.dataset.linkLabel;
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', dialog.id);
        button.addEventListener('click', openDialog);
        wrap.appendChild(button);
        label.appendChild(wrap);
      });
    };

    closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        enhanceEdp();
      });
    });

    enhanceEdp();
    observer.observe(document.body, {childList:true,subtree:true});
  })();
  } catch(e) { console.error(e); }
})();

})();
